export default {"src":"/_next/static/media/homeTwo.6ab4291d.svg","height":424,"width":480,"blurWidth":0,"blurHeight":0};